import { render, staticRenderFns } from "./muhe_config.vue?vue&type=template&id=5d780b61&scoped=true"
import script from "./muhe_config.vue?vue&type=script&lang=ts"
export * from "./muhe_config.vue?vue&type=script&lang=ts"
import style0 from "./muhe_config.vue?vue&type=style&index=0&id=5d780b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d780b61",
  null
  
)

export default component.exports